import { supertypeClass, property, Persistable, Supertype } from '@haventech/amorphic';

import { Account } from '../Account';
import { ManagedEntityType } from './ManagedEntityType';

@supertypeClass({ toClient: true, toServer: false })
export class AccountAuthorization extends Persistable(Supertype) {
  @property({
    toServer: false,
    toClient: false,
    getType: () => Account,
  })
  account: Account;

  @property({
    toServer: false,
    toClient: false,
    getType: () => ManagedEntityType,
  })
  managedEntityType: ManagedEntityType;

  @property({
    toServer: false,
    toClient: false,
  })
  managedEntityId: string;

  @property({
    comment: 'timestamp',
    toServer: false,
  })
  createdTime: Date;

  private constructor() {
    super();
  }

  static new(
    customerAccount: Account,
    managedEntityType: ManagedEntityType,
    managedEntityId: string
  ): AccountAuthorization {
    return new AccountAuthorization().init(customerAccount, managedEntityType, managedEntityId);
  }

  private init(
    customerAccount: Account,
    managedEntityType: ManagedEntityType,
    managedEntityId: string
  ): AccountAuthorization {
    this.account = customerAccount;

    this.managedEntityType = managedEntityType;
    this.managedEntityId = managedEntityId;

    return this;
  }
}
